import { store } from '../../store/store'

export const requestBody = {

  getRequestBody ({ methodName, methodParameters }) {
    methodParameters = JSON.parse(JSON.stringify(methodParameters))
    if (this[methodName + 'RequestBody']) {
      return this[methodName + 'RequestBody']({ methodParameters })
    } else {
      return methodParameters
    }
  },

  initRequestBody ({ methodParameters }) {
    let finalRequestBody = {
      srciTransactionId: store.getters.srciTransactionId,
      srcInitiatorId: store.getters.srcClientId,
      srciDpaId: store.getters.srcDpaId,
      dpaTransactionOptions: methodParameters.dpaTransactionOptions
    }
    return finalRequestBody
  },

  initiateIdentityValidationRequestBody ({ methodParameters }) {
    let validationChannelId = methodParameters['requestedValidationChannelId']
    // eslint-disable-next-line
    let regex = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/
    if (regex.test(validationChannelId)) {
      return {
        requestedValidationChannelId: 'EMAIL_ADDRESS'
      }
    } else {
      return {
        requestedValidationChannelId: 'MOBILE_PHONE_NUMBER'
      }
    }
  }
}
